export function isExcludedFromDefaultApplication(app: {
  exclude_from_default_application?: boolean;
  metadata?: { exclude_from_default_application?: boolean } | null;
} | null | undefined): boolean {
  return (
    app?.exclude_from_default_application === true ||
    app?.metadata?.exclude_from_default_application === true
  );
}
